import React from 'react'
import PanelNav, { PanelNavProvider, PanelEnabled } from './PanelNav'
import { BenefitsBulletList, Testimonial, CoachChatFeature } from './components'
import { AylaPanel, WebinarPanel } from './commonPanels'
import useTranslation from '../../../shared/TranslationProvider'

const SelectBenefitsPanel = () => {
  const items = [...Array(6).keys()].map(
    (key) => `RightPanel.select.item${key}`,
  )
  const { locale } = useTranslation()
  const isUsEnglish = locale === 'en'
  return (
    <>
      <PanelEnabled thisPanelNumber={0}>
        <PanelNav />
        <BenefitsBulletList items={items} />
        {isUsEnglish ? <CoachChatFeature /> : <Testimonial />}
      </PanelEnabled>
    </>
  )
}

const RightPanelSelect = () => {
  const { locale } = useTranslation()
  if (locale.slice(0, 2) === 'en') {
    return (
      <PanelNavProvider panelCount={3}>
        <SelectBenefitsPanel />
        <WebinarPanel />
        <AylaPanel />
      </PanelNavProvider>
    )
  } else {
    return (
      <PanelNavProvider panelCount={2}>
        <SelectBenefitsPanel />
        <AylaPanel thisPanelNumber={1} />
      </PanelNavProvider>
    )
  }
}

export default RightPanelSelect
